import { takeLatest, takeEvery, call, put } from 'redux-saga/effects';
import _ from 'lodash';

import { firestore } from '../utils/firebase';
import { convertCollection } from '../utils/helper';
import { getTenantPath, updateSaga, setSaga } from '../sagas/helper';
import { fetchPrintersRoutine, savePrinterRoutine, removePrinterRoutine } from '../routines';

function* watchFetchPrintersSaga() {
  // run fetchDataFromServer on every trigger action
  yield takeEvery(fetchPrintersRoutine.TRIGGER, fetchPrintersSaga);
}

function fetchPrinters() {
  return firestore.collection(getTenantPath('/printers'))
    .get()
    .then(convertCollection);
}

function* fetchPrintersSaga() {
  try {
    // trigger request action
    yield put(fetchPrintersRoutine.request());
    // perform request to '/some_url' to fetch some data
    const printers = yield call(fetchPrinters);
    // if request successfully finished
    yield put(fetchPrintersRoutine.success({ success: true, printers }));
  } catch (err) {
    console.error(err);
    // if request failed
    yield put(fetchPrintersRoutine.failure({ success: false }));
  } finally {
    // trigger fulfill action
    yield put(fetchPrintersRoutine.fulfill());
  }
}

function* watchSavePrinterSaga() {
  yield takeLatest(savePrinterRoutine.TRIGGER, setSaga(savePrinterRoutine, (payload) => getTenantPath(`/printers/${payload.values.get('id')}`), (payload) => _.omit(payload.values.toJS(), ['id'])));
}

function* watchRemovePrinterSaga() {
  yield takeLatest(removePrinterRoutine.TRIGGER, updateSaga(removePrinterRoutine, (printer) => getTenantPath(`/printers/${printer.id}`), () => ({ deleted: { at: new Date().toISOString() } })));
}

export {
  watchFetchPrintersSaga,
  watchSavePrinterSaga,
  watchRemovePrinterSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/printers.js